import React from "react";
import { Box, Card, CardBody, Grid, GridItem, useColorModeValue } from "@chakra-ui/react";
import ListPageCardHeader from "components/Card/ListPageCardHeader";
import { ManagerialChart } from "./ManagerialChart";

export function ManagerialCard({ title, charts, minH = { base: "400px", md: "49vh" } }) {
    return (
        <Card flex="1" minW={{ base: "100%", md: "0" }} overflow="hidden" minH={minH}>
            <Box p={4}>
                <ListPageCardHeader align="center" title={title} bg={useColorModeValue("white", "navy.900")} />
            </Box>
            <CardBody>
                <Grid templateColumns={{ base: "1fr", md: `repeat(${charts.length}, 1fr)` }} gap="4">
                    {charts.map((chart, idx) => (
                        <GridItem key={idx} w="100%">
                            <ManagerialChart data={chart.data} layout={chart.layout} style={chart.style} config={chart.config} />
                        </GridItem>
                    ))}
                </Grid>
            </CardBody>
        </Card>
    );
}